
export const themeConfig = {
    token: {
        colorPrimary: "#25B5F8",
    },


};